// src/theme.js
import colors from 'vuetify/es5/util/colors'
import AgentTheme from './agent_theme';

export default {
  primary: {
    base: AgentTheme.getAgentTheme().colors.primary.base,
    darken1: colors.blueGrey.darken2
  },
  secondary: colors.blueGrey.lighten2,
  // All keys will generate theme styles,
  // Here we add a custom `tertiary` color
  //#7c0000,#0d4c75
  tertiary: colors.pink.base,
  iconfont: 'md',
}